import * as THREE from 'three'
import * as datGui from 'dat.gui'
import { IPostEffects } from '../posteffects'
import { addBloomGUI } from './Bloom.gui'
import { addDepthOfFieldGUI } from './DepthOfField.gui'
// import { addSsaoGUI } from './SSAO.gui'
import { addN8aoGUI } from './N8AO.gui'
import { addAntiAliasingGUI } from './SMAA.gui'
import { addTonemappingGUI } from './Tonemapping.gui'
import { addTextureGUI } from './TextureMapping.gui'
import * as PostProcessing from 'postprocessing'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { ModelControls } from '../../utils/ModelControls'
import { addCameraGUI } from './Camera.gui'
import { addLightsGUI } from './Light.gui'
import { saveConfigs } from '../../utils/saveConfigs'
import { SceneLight } from '../../types/scene-light'
import { StoreScheme } from '../../../shared/store/store'
import { addEnvironmentGUI } from './EnvironmentGUI'

interface IGUIParams {
  renderer: THREE.WebGLRenderer
  composer: PostProcessing.EffectComposer
  postEffects: IPostEffects
  camera: THREE.PerspectiveCamera
  lights: SceneLight[]
  axesHelper: THREE.AxesHelper
  bbox: THREE.BoxHelper
  controls: ModelControls | OrbitControls
  scene: THREE.Scene
  store: StoreScheme
  cubemap: THREE.DataTexture | undefined
}

export function setupGUI({
  renderer,
  composer,
  postEffects,
  camera,
  lights,
  axesHelper,
  bbox,
  controls,
  scene,
  store,
  cubemap,
}: IGUIParams): datGui.GUI {
  const posteffectsConfig = store.getState().viewerConfig?.posteffectsConfig
  const gui = new datGui.GUI({ width: 400 })
  gui.add(axesHelper, 'visible').name('Axes Helper')
  gui.add(bbox, 'visible').name('Bounding Box Helper')

  addBloomGUI(
    gui,
    'general',
    postEffects.bloomEffect,
    postEffects.effectPass,
    posteffectsConfig?.bloom,
    store,
  )
  addBloomGUI(
    gui,
    'diamonds',
    postEffects.bloomEffectSelective,
    postEffects.effectPass,
    posteffectsConfig?.bloomSelective,
    store,
  )

  addN8aoGUI(gui, postEffects.n8aoPass, posteffectsConfig?.n8ao, store)

  addDepthOfFieldGUI(gui, postEffects.depthOfFieldEffect, posteffectsConfig?.depthOfField, store)

  /*
  const cameraDifference = camera.far - camera.near
  addSsaoGUI(gui, renderer, postEffects, posteffectsConfig?.ssao, cameraDifference, store)
  */

  addAntiAliasingGUI(
    gui,
    composer,
    renderer,
    postEffects.smaaEffect,
    posteffectsConfig?.smaa,
    store,
  )

  addTonemappingGUI(
    gui,
    renderer,
    postEffects.toneMappingEffect,
    posteffectsConfig?.toneMapping,
    store,
  )
  addTextureGUI(gui, postEffects.textureEffect, store)
  addLightsGUI(gui, lights, scene, camera, renderer, store)
  addCameraGUI(gui, camera, controls, scene, store)
  addEnvironmentGUI(gui, cubemap, store)

  const saveConfigsButton = {
    saveConfigs: () => {
      saveConfigs(lights, store)
    },
  }
  gui.add(saveConfigsButton, 'saveConfigs').name('Save viewer & widget configs')

  return gui
}
